export default (node) => {
  /**
   * Data + elements
   */

  /**
   * Functions
   */
  const validateInput = (e) => {
    const input = e.detail.node;

    const value = Number(input.value);
    const valueId = input.id;
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;

    // update the url to add
    const urlToAdd = input.dataset.filterUrlToAdd;
    const urlToRemove = input.dataset.filterUrlToRemove;
    // get the current url
    let currentUrl = window.location.pathname + window.location.search;
    // check if the filter.v.price.gte and filter.v.price.lte are in the url
    const hasMin = currentUrl.includes('filter.v.price.gte');
    const hasMax = currentUrl.includes('filter.v.price.lte');
    // get url
    // if hasMin and hasMax are true, remove them from the url
    if (hasMin) {
      if (valueId === 'price-min') {
        const newUrl = currentUrl.replace(
          /filter\.v\.price\.gte=[^&]*/,
          'filter.v.price.gte=' + value
        );
        input.setAttribute('data-filter-url-to-add', newUrl);
        currentUrl = newUrl;
      }
    } else {
      if (valueId === 'price-min') {
        const newUrl =
          currentUrl +
          `${window.location.search.length ? '&' : '?'}filter.v.price.gte=` +
          value;
        input.setAttribute('data-filter-url-to-add', newUrl);
        currentUrl = newUrl;
      }
    }

    if (hasMax) {
      if (valueId === 'price-max') {
        const newUrl = currentUrl.replace(
          /filter\.v\.price\.lte=[^&]*/,
          'filter.v.price.lte=' + value
        );
        input.setAttribute('data-filter-url-to-add', newUrl);
        currentUrl = newUrl;
      }
    } else {
      if (valueId === 'price-max') {
        const newUrl =
          currentUrl +
          `${window.location.search.length ? '&' : '?'}filter.v.price.lte=` +
          value;
        input.setAttribute('data-filter-url-to-add', newUrl);
        currentUrl = newUrl;
      }
    }

    // update the url with the currentUrl
    window.history.pushState({}, '', currentUrl);
  };

  const controlFromSlider = (fromSlider, toSlider, fromInput) => {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#EBE9E5', '#404957', toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromInput.value = from;
    }

    // dispatch event to update the filter
    document.dispatchEvent(
      new CustomEvent('price-range:validate', {
        detail: {
          node: fromInput,
        },
      })
    );
    document.dispatchEvent(new CustomEvent('collection-filter:show-buttons'));
  };

  const controlToSlider = (fromSlider, toSlider, toInput) => {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#EBE9E5', '#404957', toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
    }

    // dispatch event to update the filter
    document.dispatchEvent(
      new CustomEvent('price-range:validate', {
        detail: {
          node: toInput,
        },
      })
    );
    document.dispatchEvent(new CustomEvent('collection-filter:show-buttons'));
  };

  const controlFromInput = (fromSlider, fromInput, toInput, controlSlider) => {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#EBE9E5', '#404957', controlSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromSlider.value = from;
    }
    // dispatch event to update the filter
    document.dispatchEvent(
      new CustomEvent('price-range:validate', {
        detail: {
          node: fromInput,
        },
      })
    );
    document.dispatchEvent(new CustomEvent('collection-filter:show-buttons'));
  };

  const controlToInput = (toSlider, fromInput, toInput, controlSlider) => {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#EBE9E5', '#404957', controlSlider);
    setToggleAccessible(toInput);
    toSlider.value = to;
    toInput.value = to;
    // dispatch event to update the filter
    document.dispatchEvent(
      new CustomEvent('price-range:validate', {
        detail: {
          node: toInput,
        },
      })
    );
    document.dispatchEvent(new CustomEvent('collection-filter:show-buttons'));
  };

  const getParsed = (currentFrom, currentTo) => {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  };

  const fillSlider = (from, to, sliderColor, rangeColor, controlSlider) => {
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} 100%)`;
  };

  const setToggleAccessible = (currentTarget) => {
    const toSlider = document.querySelector('#toSlider');
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  };

  const reloadEvents = () => {
    const fromSlider = document.querySelector('#fromSlider');
    const toSlider = document.querySelector('#toSlider');
    const fromInput = document.querySelector('#price-min');
    const toInput = document.querySelector('#price-max');
    fillSlider(fromSlider, toSlider, '#EBE9E5', '#404957', toSlider);
    setToggleAccessible(toSlider);

    fromSlider.oninput = () =>
      controlFromSlider(fromSlider, toSlider, fromInput);
    toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
    fromInput.oninput = () =>
      controlFromInput(fromSlider, fromInput, toInput, toSlider);
    toInput.oninput = () =>
      controlToInput(toSlider, fromInput, toInput, toSlider);
  };

  /**
   * Init
   */
  const init = () => {
    reloadEvents();
    document.addEventListener('price-range:validate', validateInput);
  };

  init();
};
